/*
 * Shared SveTech shapes of the core UI primitives (Key design). Breakpoint-dependent radius, height
 * and padding live in CSS variables: tailwind-merge drops conflicts only within the same modifier,
 * so this way a consumer's plain `rounded-*`, `h-*` or `px-*` still wins at every breakpoint.
 */

/** Asymmetric corner: radius from `--svt-radius`, square top-right. */
export const SVT_CORNER = 'rounded-[var(--svt-radius)] rounded-tr-none';

/** Radius 12 px on phones, 15 px from `md` (buttons, fields, pagination). */
export const SVT_RADIUS = '[--svt-radius:12px] md:[--svt-radius:15px]';

/** Visible focus of every control: 2 px green ring, offset 2. */
export const SVT_FOCUS_RING =
  'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#2c7a25] focus-visible:ring-offset-2';

/** Colour transitions only (150 ms), none with reduced motion. */
export const SVT_TRANSITION = 'transition-colors duration-150 motion-reduce:transition-none';

/**
 * Field box (input wrapper, select trigger, textarea): white, 1 px #e6e8e2, green border on focus,
 * no ring. Height 56 → 50 px and padding 12 → 16 px come from variables.
 */
export const SVT_FIELD = [
  'border border-[#e6e8e2] bg-white text-[#14171a]',
  '[--svt-field-h:56px] [--svt-field-px:12px] md:[--svt-field-h:50px] md:[--svt-field-px:16px]',
  SVT_RADIUS,
  SVT_TRANSITION,
].join(' ');

/** Invalid field: red border, also while focused. */
export const SVT_FIELD_INVALID = 'border-[#b3261e] focus-within:border-[#b3261e]';
